import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalConfirm from '../../../../../../components/Modal/ConfirmLayouts';

const ServiceStatus = ({ onClose, modalData }) => {
  const [modal] = useState(modalData)
  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        <ModalConfirm.TitleDescriptionWrapper>
          <ModalConfirm.Title>{modal?.error_header}</ModalConfirm.Title>
          <ModalConfirm.Description>
            <div>{modal?.error_message}</div>
          </ModalConfirm.Description>
        </ModalConfirm.TitleDescriptionWrapper>
        <ModalConfirm.Actions>
          <Button
            onClick={onClose}
          >
            Close
          </Button>
        </ModalConfirm.Actions>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
}

ServiceStatus.propTypes = {
  modalData: PropTypes.object,
  onClose: PropTypes.func,
}

export default ServiceStatus;
